import { setModuleSource } from './../../../../api/pc/login';
import { observable, action, runInAction } from "mobx";
import { Dialog } from "@weapp/ui";
import { getAsyncHook, getLabel } from "@weapp/utils";

import * as LoginAPI from '../../../../api/pc/login';
import { loginParamsType } from "./type";
import { LoginWayProps } from "../../common/assistedLogin/type";
import {
  clearTeamsCookie,
  dealImageUrl, getCustomLoginKey,
  getQueryString, isCustomLoginPath, isCustomPageOrCusDomain,
  isEcologyEnv,
  setAccountStorage,
  setAreaCodeStorage,
  setMainHostCookie,
  setTokenStorage
} from "../../../../utils";
import { ResetPass } from "../../common/resetpass";

import PcSkinStore from '../../loginPool/skinStore';
import { LOCATION_ORIGN, publicUrl } from "../../../../constants";

const { message, confirm } = Dialog;
const LOGIN_WAYS_INITIAL_DATA = () => ({
  accountBox: true,
  passwordBox: true,
  dynamicPasswordBox: false,
  dynamicTokenBox: false,
  caLoginBox: false,
  contractLockBox: false,
  contractAuthWay: false,
  pcForceScanBox: false
})
export class LoginStore {
  @observable faviconUrl: string = ""
  @observable qrcodeUrl: string = '';//二维码链接
  @observable scanVisible: boolean = false;//二维码显示
  @observable scanVisibleFade: boolean = false;//二维码淡入
  @observable scanRefreshVisible: boolean = false;//二维码失效刷新
  @observable thirdList: any = [];//三方登录
  @observable loginActiveKey: string = localStorage.getItem('e_loginConfig') || 'unset';//当前登录配置方式
  @observable loginConfigData: any = [];//配置登录方式
  @observable loginCheckboxConfigData: any = [];//配置登录方式
  @observable currentLang: string = "zh_CN";//当前国际化语言
  @observable skinSettingData: any = {};
  @observable qrcodeRate: number = 1000;
  @observable qrEffectiveTime: any = '';
  @observable loginCallback: any = null;
  @observable qysCheckAuthUrl: string = '';
  @observable qysDialogShown: boolean = false;
  @observable qysQrcodeExpired: boolean = false;
  @observable isEbDesign: boolean = false;
  @observable thirdLoading: boolean = false;  //三方登录检查loading
  @observable loginLoading: boolean = false;//登录中loading
  //二维码轮询
  timer: any = null;
  qysTimer: any = null;

  // 外部传入路由方法 = this.props.history.push
  routePush: any = null;

  //初始数据
  @action
  init = (routePush: any, isEbDesign: boolean = false) => {
    // this.checkLogin();
    if (isEbDesign) {
      this.isEbDesign = true;
    }
    this.routePush = routePush;
    this.thirdList = [
      { type: 'qq', url: '/papi/passport/qq/qqLogin' },
      { type: 'weibo', url: '/papi/passport/weibo/weiboLogin' },
      { type: 'wechat', url: '/papi/passport/wechat/wechatLogin' },
      { type: 'wxwork', url: '/papi/passport/wechat/wechatEnterpriseLogin' }
    ]
    this.loginConfigData = [
      { id: "account", content: getLabel('93514', '记住账号'), activeIcon: 'Icon-correct01' },
      { id: "accountAndPassword", content: getLabel('93515', '记住账号密码'), activeIcon: 'Icon-correct01' },
      { id: "autoLogin", content: getLabel('93516', '自动登录'), activeIcon: 'Icon-correct01' },
      { id: "unset", content: getLabel('93517', '不记住账号'), activeIcon: 'Icon-correct01' }
    ]
    this.loginCheckboxConfigData = [
      { id: "account", content: getLabel('93514', '记住账号'), activeIcon: 'Icon-correct01' },
      { id: "password", content: getLabel('218911', '记住密码'), activeIcon: 'Icon-correct01' },
      { id: "autoLogin", content: getLabel('93516', '自动登录'), activeIcon: 'Icon-correct01' }
    ]
  }
  @action
  changeQysDialogShown = (visible: boolean) => {
    this.qysDialogShown = visible;
  }

  @action
  setQysQrcodeExpired = (expired: boolean) => {
    this.qysQrcodeExpired = false;
  }

  @action
  changeQysCheckAuthUrl = (value: string) => {
    this.qysCheckAuthUrl = value;
  }

  @action
  clearQysQrcode = () => {
    clearInterval(this.qysTimer);
    this.qysDialogShown = false;
    this.qysCheckAuthUrl = '';
  }
  /**
   *
   * @param value 登录配置方式
   */
  @action
  updateActiveConfigKey = (value: any) => {
    this.loginActiveKey = value;
    localStorage.setItem('e_loginConfig', value);
  }
  @action
  setLoginCallback = (callback: any) => {
    this.loginCallback = callback;
  }

  /**
   *
   * @param visible 显示扫码登录
   */
  @action
  changeScanVisible = (visible: boolean, noAnimate = false) => {
    this.scanVisible = visible;
    if (visible) {
      //二维码淡入
      const timer = setTimeout(() => {
        runInAction(() => {
          // if (noAnimate) {
          this.scanVisibleFade = true;
          // }
        })
        clearTimeout(timer);
      }, 0);
    } else {
      this.scanVisibleFade = false;
      clearInterval(this.timer);
    }
  }


  //获取二维码
  @action
  getQrcodeUrl = () => {
    if (this.isEbDesign) {
      runInAction(() => {
        this.qrcodeUrl = getLabel('216915', '扫码测试成功');
      });
      return;
    }
    LoginAPI.queryQrUrl(this.qrEffectiveTime).then((result: any) => {
      runInAction(() => {
        this.qrcodeUrl = result.data.url;
        //关闭刷新按钮
        this.scanRefreshVisible = false;
        //开始轮询
        clearInterval(this.timer);
        this.qrcodePolling(result.data.etoken);
      });
    })
  }
  //检查是否展示校验码
  @action
  checkVerifyCodeShow = (params: any, callback?: Function) => {
    return new Promise((resolve, reject) => {
      if (window.passport_runInfo.deployEnv === 'public' && !isCustomPageOrCusDomain()) {
        resolve(false);
      } else {
        LoginAPI.checkVerifyCodeShow(params)
          .then((result: any) => {
            runInAction(() => {
              if (result?.data?.safetyConfig?.verificationCode === 1) {
                if (!window.e_customPageData) { window.e_customPageData = {}; }
                window.e_customPageData.safetyConfig = { ...(window.e_customPageData.safetyConfig || {}), ...result?.data?.safetyConfig };
                callback && callback(result?.data);
                resolve(true)
              } else {
                callback && callback(false);
              }
              resolve(false)
            })
          })
          .catch((error) => {
            resolve(false)
          });
      }

    })
  }


  /**
   *
   * @param etoken 轮询请求etoken判断登录状态
   */
  qrcodePolling = (etoken: any) => {
    const { loginSkinData } = PcSkinStore;
    let loginRedirectUrl = "";
    if (loginSkinData?.pageInfo?.loginRedirectUrl) {
      loginRedirectUrl = loginSkinData?.pageInfo?.loginRedirectUrl;
    }
    let qrcodePollingSearchNum = 0;
    this.timer = setInterval(() => {

      if (qrcodePollingSearchNum > 60) {//2s一次轮询 ，持续两分钟
        //五分钟以后强制二维码失效，保证其可以手动刷新唤醒轮询
        clearInterval(this.timer);
        runInAction(() => {
          this.scanRefreshVisible = true;
        });
        return
      }
      qrcodePollingSearchNum++;

      LoginAPI.checkQrStatus(etoken, loginRedirectUrl).then((result: any) => {
        switch (result.data.code) {
          case -1:
            //二维码失效
            clearInterval(this.timer);
            runInAction(() => {
              this.scanRefreshVisible = true;
            });
            break;
          case 1:
            //登录成功
            clearInterval(this.timer);
            if (getQueryString('moduleSource')) {
              setMainHostCookie('E10_moduleSource', getQueryString('moduleSource'));
            }
            window.location.href = result.data.redirect;
            break;
          case -2:
            //扫码报错
            message({
              type: "info",
              content: result.data.msg
            });

        }
      })
    }, 2000)
  }

  /**
   *
   * @param params 轮询请求etoken判断登录状态
   */
  QysQrcodePolling = (params: any) => {
    const startTime = new Date().getTime();
    const expireTime = 4 * 60 * 1000;
    this.qysTimer = setInterval(() => {
      LoginAPI.checkQysQrStatus(params).then((result: any) => {
        if (result?.data?.loginData?.redirectUrl) {
          clearInterval(this.qysTimer);
          window.location.href = result.data.loginData.redirectUrl;
        }
        if (new Date().getTime() - startTime > expireTime) {
          clearInterval(this.qysTimer);
          runInAction(() => {
            this.qysQrcodeExpired = true
          })
        }
      });
    }, this.qrcodeRate);
  }
  @action
  setModuleSource = (value: any, callback?: any) => {
    LoginAPI.setModuleSource(value).then(() => {
      callback && callback()
    });
  }
  @action
  clearWeappCookie = (value: any, callback?: any) => {
    LoginAPI.clearWeappCookie(value).then(() => {
      callback && callback()
    });
  }
  //登录
  @action
  getLogin = (loginParams: loginParamsType, onError?: any) => {
    const beforeLoginHook = getAsyncHook('weappPassportWeb', 'beforeLogin');
    if (beforeLoginHook) {
      beforeLoginHook(0)
    }
    loginParams.passportCusLoginDomain = LOCATION_ORIGN;
    if (window.location.pathname.indexOf('/customlogin') > -1) {
      loginParams.passportCusLoginPath = window.location.pathname.replace(publicUrl, '');
    }
    this.loginLoading = true
    LoginAPI.login({...loginParams}).then((result: any) => {

      runInAction(() => {
        this.loginLoading = false;//关闭登录loading
      })
      if (result?.code === "20211217") {
        message({
          type: "error",
          content: result.msg,
          delay: 2000
        })
        return
      }
      if (result?.data?.errorMsg) {
        const msg = result.data.errorMsg
        message({
          type: "error",
          content: msg.alreadyTranslate ? msg.msg : getLabel(msg.i18nId, msg.msg),
          delay: 2000
        });
        onError && onError();
      } else if (result?.code === 500) {
        message({
          type: "error",
          content: getLabel('249552', '系统错误，请稍后再试'),
          delay: 2000
        })
      } else {
        switch (this.loginActiveKey) {
          case 'unset':
            localStorage.removeItem('e_login_accont');
            localStorage.removeItem('e_login_psw');
            localStorage.removeItem('e_login_loginType')
            break;
          case 'account':
            localStorage.setItem('e_login_accont', loginParams.account);
            localStorage.setItem('e_login_loginType', PcSkinStore?.activeLoginType)
            localStorage.removeItem('e_login_psw');
            break;
          case 'accountAndPassword':
            localStorage.setItem('e_login_accont', loginParams.account);
            localStorage.setItem('e_login_loginType', PcSkinStore?.activeLoginType)
            if (result.data?.encryptPassword) {
              localStorage.setItem('e_login_psw', result.data.encryptPassword);
            }
            break;
          case 'autoLogin':
            localStorage.setItem('e_login_accont', loginParams.account);
            localStorage.setItem('e_login_loginType', PcSkinStore?.activeLoginType)
            if (result.data?.encryptPassword) {
              localStorage.setItem('e_login_psw', result.data.encryptPassword);
            }
            break;
        }
        const afterLoginHook = getAsyncHook('weappPassportWeb', 'afterLogin');
        if (afterLoginHook) {
          afterLoginHook(0)
        }
        if (result.data?.needQysCheck) {
          this.changeQysCheckAuthUrl(result.data?.qysCheckAuthUrl || '');
          this.changeQysDialogShown(true);
          this.setQysQrcodeExpired(false);
          //轮询契约锁状态
          this.QysQrcodePolling({
            tenantKey: result.data?.tenantKey,
            qysCheckAuthId: result.data?.qysCheckAuthId
          })
          return;
        }
        //管理员重置密码强制用户修改
        if (result?.data?.needPwdChange) {
          ResetPass.showDialog({ account: loginParams.account, oldPassword: loginParams.password }).then(() => {
            message({ type: "success", content: getLabel('154716', '修改成功，请重新登录') });
          });
          return;
        }
        //登录成功--有团队
        if (result.data?.hasTenant) {
          if (this.loginCallback) {
            this.loginCallback(result.data?.stTicket);
          } else {
            LoginAPI.clearCookie().then(() => {
              clearTeamsCookie();
              let redirectUrl = result.data.redirectUrl;
              if (getQueryString("intunifyauth_client") === "freepass" || getQueryString("wea_link_keep_intunifyauth_client") === "freepass") {
                redirectUrl = redirectUrl.replace("ticket=", "intunifyauth_client=freepass&ticket=")
              }
              window.location.replace(`${redirectUrl}${result.data.redicretModuleSource ? `&redirectModuleSource=${result.data.redicretModuleSource}` : ``}`);
            })
          }

        } else {
          if (result.data?.userIdToken) {
            setTokenStorage(result.data.userIdToken);
            setAccountStorage(loginParams.account);
            setAreaCodeStorage(null);
            if (isEcologyEnv()) {//e10迁移环境无团队直接跳往eteams
              this.ecToEteams();
              return
            }
            let params = '';
            if (!getQueryString('wea_link_keep_customlogin') && isCustomLoginPath()){
              const customLoginKey = getCustomLoginKey();
              params = `?wea_link_keep_customlogin=${customLoginKey}`
            }
            this.routePush(`${publicUrl}/signup/tenant${params}`);
          }
        }
      }
    }).catch(() => {
      runInAction(() => {
        this.loginLoading = false;//关闭登录loading
      })
    });
  }

  @action
  ecToEteams = () => {//ec无团队下跳eteams
    this.loginLoading = false;
    confirm({
      content: getLabel('227055', '当前账号非e10私有化账号，请前往云端登录'),
      onOk: () => {
        window.open('https://weapp.eteams.cn')
      },
      onCancel: () => {
        console.log('Cancel');
      },
      destroy: () => {
      }

    });

  }
  @action
  appThirdSignLogin = (data: any) => {
    this.updateThirdLoading(true);
    LoginAPI.signLogin(data).then((result) => {
      this.updateThirdLoading(false);
      this.afterThirdLogin(result, data.service);
    }).catch(() => {
      this.updateThirdLoading(false);
    })
  }

  @action
  appThirdOpenLogin = (data: { appkey: string, appsecret: string, account: string, service: string }) => {
    this.updateThirdLoading(true);
    LoginAPI.openApiLogin({
      appkey: data.appkey,
      appsecret: data.appsecret,
      account: data.account,
      service: data.service
    }).then((result) => {
      this.updateThirdLoading(false);
      this.afterThirdLogin(result, data.service);
    }).catch(() => {
      this.updateThirdLoading(false);
    })
  }

  @action
  afterThirdLogin(result: any, service: string) {
    if (result?.data?.errorMsg) {
      const msg = result.data.errorMsg
      message({
        type: "error",
        content: msg.alreadyTranslate ? msg.msg : getLabel(msg.i18nId, msg.msg),
        delay: 2000
      });
    } else {
      const afterLoginHook = getAsyncHook('weappPassportWeb', 'afterLogin');
      if (afterLoginHook) {
        afterLoginHook(0)
      }
      //登录成功
      console.info("第三方登录成功:" + new Date().getTime())

      //app单点登录标志
      window.TEAMS.appThirdLogin = true;

      window.location.href = service || "/"

    }
  }

  @action
  updateThirdLoading(loading: boolean) {
    this.thirdLoading = loading;
  }


  //登录前查询企业logo
  queryLogo = async () => {
    const res = await LoginAPI.queryLogo(window.e_customPageData?.tenantKey);
    let hrefValue = dealImageUrl(res.data?.faviconUrl)

    if (hrefValue && hrefValue.indexOf("https://dl.eteams.cn/noauth") > -1) {
      hrefValue = hrefValue.replace("https://dl.eteams.cn/noauth", "https://weapp.eteams.cn/api/file/preview?fileId=");
    }

    if (hrefValue && hrefValue.indexOf("http://dl.eteams.cn/noauth") > -1) {
      hrefValue = hrefValue.replace("http://dl.eteams.cn/noauth", "https://weapp.eteams.cn/api/file/preview?fileId=");
    }
    document.querySelector('link[rel="icon"]')?.setAttribute('href', hrefValue);
  }
}

const instance = new LoginStore();

export default instance;
export type LoginStoreType = Pick<LoginStore, keyof LoginStore>;
